// extracted by mini-css-extract-plugin
export default {"root":"kS_OwpKKVi35b6Rd29Sx","name":"YY3eLRt10F25xpgwdLSu","details":"m4DRrxJVBTgmmLtWNMRC"};